import React, { FC } from 'react';
import theme from '@buoyhealth/common.buoy-theme';
import { Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color?: Color;
};

const PocketIcon: FC<Props> = ({
  className = '',
  color = theme.palette.common.white,
}) => (
  <Svg
    width="29px"
    height="29px"
    viewBox="0 0 29 29"
    className={className}
    fill="transparent"
  >
    <desc>Pocket Icon.</desc>
    <path
      d="M27.8682 14.4775C27.8682 21.9334 21.824 27.9775 14.3682 27.9775C6.91232 27.9775 0.868164 21.9334 0.868164 14.4775C0.868164 7.0217 6.91232 0.977539 14.3682 0.977539C21.824 0.977539 27.8682 7.0217 27.8682 14.4775Z"
      stroke={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2124 14.0107L14.6727 17.5501C14.4929 17.7299 14.2566 17.8185 14.0208 17.8165C13.7687 17.8254 13.5242 17.7289 13.3461 17.5501L9.80714 14.0107C9.45153 13.6553 9.45244 13.0787 9.80714 12.7239C10.1623 12.3684 10.7378 12.3679 11.0939 12.7239L14.0097 15.6399L16.9257 12.7239C17.2802 12.3684 17.8578 12.3693 18.2124 12.7239C18.5681 13.0793 18.5681 13.6547 18.2124 14.0107ZM20.863 10.7749C20.863 9.77375 20.0568 8.96216 19.0642 8.96216H19.0641H8.95515C7.9616 8.96216 7.15625 9.77401 7.15625 10.7749V15.7968C7.15625 15.8899 7.16326 15.9815 7.177 16.071C7.16303 16.2057 7.1561 16.3411 7.15625 16.4765C7.15625 19.3551 10.2244 21.6895 14.0096 21.6895C17.7947 21.6895 20.863 19.3551 20.863 16.4766C20.863 16.3399 20.8557 16.2047 20.8422 16.071C20.8557 15.9816 20.863 15.8899 20.863 15.7968V10.7749Z"
      fill={color}
    />
  </Svg>
);

export default PocketIcon;
